'use client'
import React from 'react';
import { SectionContent } from "@/types/sections.model";
import { Box, Container, Grid, Typography } from "@mui/material";
import Row from "../ui/Row";
import FadeIn from "../ui/FadeIn";
import Media from '../ui/Media';
import Image from 'next/image';

const Highlights: React.FC<{ section: SectionContent<'highlight'> }> = ({ section }) => {
  const { id, content, style, item, } = section;

  const textAlign = style?.alignment === 'center' ? 'center' : 'left';

  return (
    <>
      <Box
        id={id}
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          pt: { xs: 32, lg: 48 },
          pb: { xs: 32, lg: 45 },
          backgroundImage: {
            xs: 'url(/assets/image/bg_highlight_mobile.svg)',
            lg: 'url(/assets/image/bg_highlight.svg)'
          },
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: { xs: 'top', lg: 'top center' }
        }}
      >
        <Container>
          <Row justifyContent={{xs: "flex-start", lg: "center"}} alignItems={{xs: "flex-start", lg: "center"}}>
            
            <Grid size={{xs: 12, lg: 6}} textAlign={textAlign} mb={6}>
              <FadeIn>
                {content.title && (
                  <Typography variant="displaySM" component={"h2"} mb={12}>
                    {content.title}
                  </Typography>
                )}
                {content.subtitle && (
                  <Typography variant="headlineMDMedium" component={"p"}>
                    {content.subtitle}
                  </Typography>
                )}
              </FadeIn>
            </Grid>

            <Grid size={{xs: 12, lg: 4}}>
              <Media item={item} />
            </Grid>
          </Row>

          <Row mt={{xs: 12, lg: 44}}>
            <Grid size={{lg: 6}}>
              <FadeIn>
                <Image src="/assets/image/highlight_1.png" alt="Highlight Image" width={592} height={720}/>
              </FadeIn>
            </Grid>
            <Grid size={{lg: 6}}>
              <FadeIn>
                <Image src="/assets/image/highlight_2.png" alt="Highlight Image" width={592} height={720}/>
              </FadeIn>
            </Grid>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default Highlights;